import { render, staticRenderFns } from "./GridTranslatorBox.vue?vue&type=template&id=687a9fde"
import script from "./GridTranslatorBox.vue?vue&type=script&lang=js"
export * from "./GridTranslatorBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports